import { createSlice } from "@reduxjs/toolkit";

import { requestSize } from "../requests/thunks/requestSize";
import { requestSizeUpdate } from "../requests/thunks/requestSizeUpdate";
import { requestDesign_Aggregated } from "../requests/thunks/requestDesign_Aggregated";
import { requestDesignUpdate } from "../requests/thunks/requestDesignUpdate";

const initialState = {
  Widths: [],
  AddonWidths: [],
  // IMPORTANT: Wrong name in CGE API, this is actually 'Depthts'
  Heights: [],
  Corners: [],
  Relations: [],
  GroupAreas: [],
  Partier: [],
  Colors: [],
  Accessories: [],
  Roofs: [],
  Seasons: [],
};

const handleSizeResponse = (state, action) => {
  const { cgeObj } = action.payload;

  const { Widths, AddonWidths, Heights, Corners, Relations } = cgeObj;

  state.Widths = Widths;
  state.AddonWidths = AddonWidths;
  // IMPORTANT: ('Depths')
  state.Heights = Heights;

  // CGE API can omit 'Corners', in that case we use default value []
  state.Corners = Corners || [];

  /*
  'Relations' can be included in the response in step 3
  It's not used for the UI but we will save it to the store anyway

  (It's also included in response for step 5 but we ignore it
  for step 5 since we don't need Options at all in step 5)
  */
  state.Relations = Relations || [];
};

const handleDesignResponse = (state, action) => {
  const { cgeObj } = action.payload;
  const {
    Relations,
    GroupAreas,
    Partier,
    Colors,
    Accessories,
    Roofs,
    Seasons,
  } = cgeObj;

  // Use default values below if property is omitted (undefined) by CGE in response
  state.Relations = Relations || [];
  state.GroupAreas = GroupAreas || [];
  state.Partier = Partier || [];
  state.Colors = Colors || [];
  state.Accessories = Accessories || [];
  state.Roofs = Roofs || [];
  state.Seasons = Seasons || [];
};

const OptionsSlice = createSlice({
  name: "Options",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(requestSize.fulfilled, handleSizeResponse)
      .addCase(requestSizeUpdate.fulfilled, handleSizeResponse)
      .addCase(requestDesign_Aggregated.fulfilled, handleDesignResponse)
      .addCase(requestDesignUpdate.fulfilled, handleDesignResponse);
  },
});

export default OptionsSlice.reducer;
